import * as React from "react";
import {
    type IconLookup,
    type IconName,
    type IconPrefix,
    type IconProp,
} from "@fortawesome/fontawesome-svg-core";

export function isIconName(icon: IconProp): icon is IconName {
    if(Array.isArray(icon)) {
        return false; // [IconPrefix, IconName] type
    } else if(typeof icon === "string") {
        return true; // IconName type
    }

    return false; // IconLookup type
}

export function isIconLookup(icon: IconProp): icon is IconLookup {
    return typeof icon === "object" && !Array.isArray(icon);
}

export interface ShopfrontIconProps extends React.HTMLProps<HTMLSpanElement> {
    icon: IconProp;
    spin?: boolean;
    pulse?: boolean;
    ignoreClass?: boolean;
}

export default class FontAwesomeLight extends React.Component<ShopfrontIconProps> {
    public render(): React.ReactNode {
        const {
            icon,
            pulse,
            spin,
            className,
            ignoreClass,
            ...props
        } = this.props;

        let iconArray: [IconPrefix, IconName];

        if(isIconName(icon)) {
            iconArray = [ "fal", icon ];
        } else if(isIconLookup(icon)) {
            iconArray = [ icon.prefix, icon.iconName ];
        } else {
            iconArray = icon;
        }

        const classes = [ iconArray[0], `fa-${iconArray[1]}`, "fa-fw" ];

        if(!ignoreClass) {
            classes.push("shopfront-icon");
        }

        if(className) {
            classes.push(className);
        }

        if(spin) {
            classes.push("fa-spin");
        }

        if(pulse) {
            classes.push("fa-pulse");
        }

        return <i
            {...props}
            className={classes.join(" ")}
        />;
    }
}
